<template>
    <card-seplag titulo="Cadastro de Perfis">        
        <card-seplag > 
            <div class="p-grid p-fluid">         
                <div class="p-col-12 p-md-4" >
                    <Button  style="margin-top:3%;" label="Novo Perfil" class="p-button-info" icon="pi pi-check" @click="modalPerfil()"/>
                </div>   
                <div class="p-col-12">
                    <DataTable :value="perfis" >
                        <Column headerStyle="width: 10%" header="#">
                            <template #body="slotProps">
                                <Button type="button" icon="pi pi-pencil" class="p-button-success" style="margin-right: .5em"  @click="modalPerfil(slotProps.data)"> </Button>
                                <Button type="button" icon="pi pi-trash" class="p-button-danger" @click="removerPerfil(slotProps.data)"> </Button>
                            </template>
                        </Column>
                        <Column field="nomePerfilAcesso" header="Perfil de Acesso"></Column>
                        <Column field="sistema.nomeSistema" header="Sistema" headerStyle="width:30%;"></Column>
                    </DataTable>
                </div>        
            </div>            
        </card-seplag>          
        <Dialog :header="nomeDialogo" :visible.sync="exibirModalPerfil" :contentStyle="'width:60rem; '">  
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <TabView>
                        <TabPanel>                    
                            <template slot="header">
                                <i class="pi pi-user-edit"></i>
                                <span>Cadastro</span>
                            </template> 
                            <br>
                            <div class="p-grid p-fluid" style="padding-bottom: 2%;">        
                                <Rotulo nome="Nome:" cols="12" >
                                    <InputText type="text" v-model="registro.nomePerfilAcesso"  placeholder="Nome"   />
                                </Rotulo>
                                <Rotulo nome="Nível de acesso:" cols="12 6" >
                                    <Dropdown v-model="registro.nivelAcesso" :options="nivelAcesso" optionLabel="name" placeholder="Selecione um nível de acesso" />
                                </Rotulo> 
                                <Rotulo nome="Filtro Visualização:" cols="12 6" >
                                    <Dropdown v-model="registro.filtroVisualizacao" :options="filtroVisualizacao" optionLabel="name" placeholder="Selecione um Filtro Visualização" />
                                </Rotulo> 
                            </div>      
                        </TabPanel>
                        <TabPanel>            
                            <template slot="header">
                                <i class="pi pi-cog"></i>
                                <span>Autorizações</span>
                            </template>
                            <br>    
                            <div class="p-grip p-fluid">
                                <TreeTable :value="autorizacoes" selectionMode="checkbox" :selectionKeys.sync="autorizacaoSelecionada">
                                    <Column field="nomeExibir" header="Name" :expander="true"></Column>
                                    <Column field="descricaoAutorizacao" header="Descrição"></Column>
                                </TreeTable>
                            </div>
                        </TabPanel>
                    </TabView>
                </div>
                <div class="p-col-4 p-md-4" v-if="!perfilSelecionado">
                    <Button label="Cadastrar" class="p-button-info" icon="pi pi-check" />
                </div>
                <div class="p-col-4 p-md-4" v-if="perfilSelecionado">
                    <Button label="Editar" class="p-button-warning" icon="pi pi-user-edit"  @click="atualizarPerfil()"/>
                </div>
                <div class="p-col-4 p-md-4" v-if="perfilSelecionado">
                    <Button label="Deletar" class="p-button-danger" icon="pi pi-trash" />
                </div>
            </div>          
        </Dialog>   
    </card-seplag>  
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import { baseApiUrl } from '@/config/global'

const getCadastroPerfil = () => {
    return { 
        id:null,
        nomePerfilAcesso: null,
        nivelAcesso: null,
        filtroVisualizacao: null,
        autorizacoes: [],
        autorizacoesSelecionada: []
    }
}
export default {
    name: 'cadastroPerfilUsuario',
     components: { CardSeplag,Rotulo },    
    data: function(){
        return{
            perfis:  [],
            autorizacoes: [],
            autorizacaoSelecionada: [],
            novoPerfil: null,
            perfilSelecionado: null,
            permissoesAcesso: null,
            loadingAutorizacoes: false,

            nomeDialogo: "Novo Cadastro",
            registro: getCadastroPerfil(),
            exibirModalPerfil: false,
            nivelAcesso: [
                {
                    name: "Administrador do Sistema",
                    code: "SISTEMA"
                },
                {
                    name: "Administrador Setorial",
                    code: "SETORIAL"
                },
                {
                    name: "Operador do Sistema",
                    code: "OPERADOR"
                }
            ],
            filtroVisualizacao:[
                {
                    name:"Todos",
                    code: "TODOS"
                },
                {
                    name:"Somente o Setor de Lotação",
                    code: "SETOR"
                },
                {
                    name:"Somente os registros cadastrados",
                    code: "CADASTRO"
                }
            ]
        }
    },
    methods:{
        async carregarDados(){   
          this.$http.get(`${baseApiUrl}/seguranca/autorizacaos/view`).then(res=>{
              this.autorizacoes = res.data
          })  
          this.$http.get(`${baseApiUrl}/seguranca/perfilacessos`).then(res1=>{
              this.perfis = res1.data              
          })     
        },
        modalPerfil(dados=null){
            if(dados){  
                this.perfilSelecionado = dados
                this.registro = dados
                this.autorizacaoSelecionada = dados.autorizacoes
                this.registro.nivelAcesso = this.nivelAcesso.filter(function(element){
                    return element.code  == dados.nivelAcesso
                })[0]
                this.registro.filtroVisualizacao = this.filtroVisualizacao.filter(function(element){
                    return element.code  == dados.filtroVisualizacao
                })[0]
                this.registro.autorizacoes = this.autorizacoes.filter(function(element){        
                    let verifica = false      
                    for(let i=0; i< dados.autorizacoes.length; i++){
                        if(element.key == dados.autorizacoes[i].id){
                            verifica = true
                            break
                        }
                    }
                    return verifica
                })                
                this.exibirModalPerfil = true       
            } else{
                this.registro = getCadastroPerfil()
                this.exibirModalPerfil = true
            }
        },
        onPageAutorizacoes(event){
            this.$http.post(`${baseApiUrl}/seguranca/autorizacaos?page=${event.page}&size=10`)
            .then(res => {
                this.autorizacoes = res.data
            })
        },
        atualizarPerfil(){
            
        },

    },
    mounted(){
        this.carregarDados()
    }

}
</script>

<style>

</style>